import PCSList from '@src/components/_shared/PCSContainer/PCSList';

export default function PCS() {
  return <PCSList widgetId='pcs' isUnitScope />;
}
